export default __webpack_public_path__ + "static/media/27-1.9aea4b2f.mp3";